import { observable } from 'mobx'

const FIELDS = ['name', 'email', 'phone', 'message']
const data = observable({
  fullname: '',
  email: '',
  message: {question: '', answer: ''},
})

export default class ContactController {
  static update(field, value) {
    data[field] = value
  }

  static get email() {
    return data.email
  }

  static get fullname() {
    return data.fullname
  }

  static get message() {
    return data.message
  }

  static initialize() {
    FIELDS.forEach(field => field)
  }
}

ContactController.update = ContactController.update.bind(ContactController)
ContactController.initialize()



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/FormsController/Controller.js
 **/